import Action from '../../Action'
// import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import MultiSelector from '../../MultiSelector';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import InternalError from '../../generales/InternalError';
const ModalCreateHost =({buscar_cis,cisSelected, setManttoData,ManttoData,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
  const obtenerFechaActualLocal = () => {
      const ahora = new Date();
      const anio = ahora.getFullYear();
      const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
      const dia = String(ahora.getDate()).padStart(2, '0');
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
    
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
  const [loadingM,setLoadingM]=useState(false);
  const [IpValid,setIpValid]=useState(true)
  const [LatValid,setLatValid]=useState(true)
  const [LonValid,setLonValid]=useState(true)
  const [matchPassword,setMatchPassword]=useState(false)
  const [disabled,setDisabled]=useState(true)



  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError,setMsgError]=useState("")
  const [listSearchIP,setListSearchIP]=useState(false)
  // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
  // console.log(dataCriticalities)
  const dataBrands=useFetch('cassia/brands','','','GET',server)
  const [dataModels,setDataModels]=useState({
    data: [],
    loading: true,
    error: null})

  const handleChange=(e)=>{
    const {name,value}=e.target
    if(e.target.name==="criticality"){
        setManttoData((prevState)=>{
            return {
                ...prevState,
                [name]:value===""?0:(parseInt(value))
            }
            
        })
    }if(e.target.name==="host"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value.trimStart()
              }
              
          })
      }   else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value==0)?1:0
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



    if(e.target.name==="agent_ip"){
        if(value==""){
            setIpValid(true)
        }else{
            setIpValid(validateIp(value))
        }
      }
    if(e.target.name==="location_lat"){
      if(value==""){
          setLatValid(true)
      }else{
        setLatValid(validarLatitud(value))
      }
    }

    if(e.target.name==="location_lon"){
      if(value==""){
          setLonValid(true)
      }else{
        setLonValid(validarLongitud(value))
      }
    }
  }



  useEffect(()=>{
   
        if( ManttoData.host=="" || ManttoData.name=="" || IpValid==false || LatValid==false || LonValid==false  || ManttoData.agent_ip=="" || ManttoData.agent_ip==null ||
           ManttoData.location_lat==""  || ManttoData.location_lon=="" || ManttoData.groupids.length==0
        
        ){
          setDisabled(true)
        }else{
          setDisabled(false)
        }
  },[ManttoData])


  const Registrar=()=>{
    let method='POST'
    let url_add=''
    if(editActive){
        method='PUT'
        url_add=groupSelected.hostid
    }

    let  body ={}


    setLoading(true)
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/hosts/'+url_add, {
       method: method,  
       headers: {
          "Accept": "application/json",
         // 'Content-Type': 'application/json',
         'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(ManttoData),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       // Manejo de la respuesta
       setData(data1)
      
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
       // console.log(data1);
       closCreateCisModal()
     setRegisterIsValid(true)
     buscar_cis()
     const timer = setTimeout(() => {
       setRegisterIsValid(false)
       setEditActive(false)
       closCreateCisModal()
     }, 3000);
   
     } else {
       const data1 = await response.json();
       handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
         
          // setManttoData({type_id:0,name:""})
          
      setLoading(false)
        // Manejo de errores
        setError(error)
        closCreateCisModal()
        setRegisterIsValid(true)
      //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        const timer = setTimeout(() => {
          setRegisterIsValid(false)
          setEditActive(false)
          closCreateCisModal()
        }, 3000);
        console.error(error);
      }
    };

    fetchDataPost();
  }

  const buscar_host=(ip)=>{
    setLoadingM(true)
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
         method: 'GET',  
         headers: {
           'Content-Type': 'application/json',
           'accept': 'application/json',
           'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
         },
       });
     //   console.log(response)
     if (response.ok) {
       const data1 = await response.json();
       setLoadingM(false)
       if(data1.data.length==0){
          
       setIpValid(true)
       }else{
           
           setMsgError("La IP ya existe")
           setIpValid(false)
       }

       setDisabled(true)
     } else {
       const data1 = await response.json();
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const changeMultiOption=(option,index,titulo)=>{
    let attr=""
    if(titulo=="Grupos"){
      attr="groupids"
    }

      setManttoData((prevState)=>{
          return {
              ...prevState,
              [attr]:option.map(item => item.value)
          }
          
      })
  }
  const changeOption=(option,index)=>{
      
      let attr=""
    if(option.filter=="Marcas"){
      attr="brand_id"
    }else if(option.filter=="hostModel"){
      attr="model_id"
    }else if(option.filter=="techDevices"){
      attr="device_id"
    }else if(option.filter=="proxy"){
      attr="proxy_id"
    }else if(option.filter=="Grupos"){
      attr="zona_groupid"
    }


      setManttoData((prevState)=>{
          return {
              ...prevState,
              [attr]:option.value===0?null:(parseInt(option.value))
          }
          
      })
      // setManttoRelation(option.value)
          
  }

  const validarLatitud = (lat) => {
    return lat >= -90 && lat <= 90 && lat.toString().includes('.');
  };
  const validarLongitud = (lng) => {
    return lng >= -180 && lng <= 180 && lng.toString().includes('.');
  };

  const validateIp= (ip) => {
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let result = ipRegex.test(ip);
    if(result){
        // buscar_host(ip)
    }else{
        
        setMsgError("Direccion ip no valida")
        
    }
    return result;
  };
  const [resultList,setResultList]=useState([])


  //   console.log(resultList)

  const closeListSearch=()=>{
      setListSearchIP(false)
  }
  const [listSelected,setListSelected]=useState(1)
  const [internalError,setInternalError]=useState(false)
  const hadleChangeList=(e)=>{
    setInternalError(false)
    setListSelected(e)
}

  const reqField=()=>{
    return(
      <p className='reqField-gs'>
        *
      </p>
    )
  }
  useEffect(()=>{
    if(ManttoData.brand_id!=null){
      search_marcas(ManttoData.brand_id)
    }
    
  },[ManttoData.brand_id])
  const search_marcas = (brand_id) => {
    // setLoadingCis(true)
    setDataModels({
      data: dataModels.data,
      loading: true,
      error: null})
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/host_models/by_brand/"+brand_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          // setDataModels(data1);
          setDataModels({
            data: data1,
            loading: false,
            error: null})
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const {
    host,
    name,
    proxy_id,
    description,
    status,
    device_id,
    alias,
    location_lat,
    location_lon,
    serialno_a,
    macaddress_a,
    brand_id,
    model_id,
    agent_ip,
    agent_port,
    snmp_ip,
    snmp_port,
    snmp_version,
    snmp_community,
    groupids,
    zona_groupid}=ManttoData;
  return (
    //********************************************************** */
    <>
      <div className="form-GS-box" style={{'width':'40%',margin:'2%'}}> 
                             
                             
                             
                             <div className="user-box-GS disabled"  style={{height:'15%'}}>
                             <input required name="host"  type="text" value={cisSelected.folio}
                             onChange={handleChange}   disabled/>
                                 <label className='label-GS  '>{'ID '}</label>
                                 
                             </div>
                            
                             <div className="user-box-GS disabled"  style={{height:'15%'}}>
                             <input required name="name"  type="text" value={cisSelected.name}
                             onChange={handleChange}  disabled />
                                 <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}</label>
                                 
                             </div>
                             
                             <div className="user-box-GS disabled"  style={{height:'15%'}}>
                             <input required name="agent_ip"  type="text" value={cisSelected.ip}
                             onChange={handleChange} disabled />
                                 <label className='label-GS  '>{'IP'}</label>
                                 {
                                     IpValid?'':<span className='form-msg-error' style={{bottom:'0%'}}> {msgError}</span>
                                 }
                             </div>
                             <div className="user-box-GS disabled"  style={{height:'15%'}}>
                             <input required name="description"  type="text" value={cisSelected.affiliation}
                             onChange={handleChange}  disabled/>
                                 <label className='label-GS  '>{'Afiliación'}</label>
                                 
                             </div>
                            <div className="user-box-GS disabled"  style={{height:'15%'}}>
                             <input required name="description"  type="text" value={cisSelected.service}
                             onChange={handleChange}   disabled/>
                                 <label className='label-GS  '>{'Servicios'}</label>
                                 
                             </div>
                            
                             
                            
                            
                            
                             
                             
                             {/* <div className="user-box-GS" style={{height:'15%'}}>
                                 {
                                     (loading)?<LoadSimple></LoadSimple>
                                     :
                                     <>
                                     <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                     <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                     </>
                                     // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                 }
                                     
                            
                                 
                             </div> */}
                         </div>
      <div className="form-GS-box" style={{'width':'40%',margin:'2%'}}> 
          
          
          
          <div className="user-box-GS disabled"  style={{height:'15%'}}>
          <input required name="host"  type="text" value={cisSelected.location}
          onChange={handleChange} disabled />
              <label className='label-GS  '>{'Zona'}</label>
              
          </div>
         
          <div className="user-box-GS disabled"  style={{height:'15%'}}>
          <input required name="name"  type="text" value={cisSelected.group_name}
          onChange={handleChange} disabled />
              <label className='label-GS  '>{'Grupo CI'}</label>
              
          </div>
          
          <div className="user-box-GS disabled"  style={{height:'15%'}}>
          <input required name="agent_ip"  type="text" value={cisSelected.brand}
          onChange={handleChange} disabled />
              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['marca'])}</label>
             
          </div>
          <div className="user-box-GS disabled"  style={{height:'15%'}}>
          <input required name="description"  type="text" value={cisSelected.model}
          onChange={handleChange} disabled  />
              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['modelo'])}</label>
              
          </div>
         <div className="user-box-GS disabled"  style={{height:'15%'}}>
          <input required name="description"  type="text" value={cisSelected.hostid}
          onChange={handleChange}   disabled/>
              <label className='label-GS  '>{'Dispositivo Vinculado'}</label>
              
          </div>
         
          
         
         
         
          
          
          <div className="user-box-GS" style={{height:'15%'}}>
              {
                  (loading)?<LoadSimple></LoadSimple>
                  :
                  <>
                  <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                  <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                  </>
                  // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
              }
                  
         
              
          </div>
      </div>
    </>
  );
}

export default ModalCreateHost